// Canonical list of selectable services shown on the contact form checkboxes.
export const SERVICE_OPTIONS = [
  "Chemical Stripping",
  "Sandblasting",
  "Powder Coating",
  "Cerakote Application",
  "CNC Plasma Cutting",
  "Custom Metal Signage",
  "Fabrication",
  "Welding",
  "3D Printing",
  "CAD Modeling",
];
